import { createTypes } from "../../../lib/utils";

export const types = {
  ...createTypes([
    "FETCH_CART",
    "ADD_TO_CART",
    "REMOVE_FROM_CART",
    "REMOVE_ITEM",
    "CLEAR_NOTE",
    "UPDATE_NOTE",
  ]),
  TOGGLE_CART: "TOGGLE_CART",
  TOGGLE_GIFT_FORM: "TOGGLE_GIFT_FORM",
  TOGGLE_GIFT_WRAP: "TOGGLE_GIFT_WRAP",
  UPDATE_GIFT_WRAP: "UPDATE_GIFT_WRAP",
  CLOSE_GIFT_FORM: "CLOSE_GIFT_FORM",
  CLOSE_GIFT_WRAP: "CLOSE_GIFT_WRAP",
  UPDATE_CART: "UPDATE_CART",
  UPDATE_CART_IGNORE_SUBSCRIBE: "UPDATE_CART_IGNORE_SUBSCRIBE",
};
